import * as logger from "loglevel";
import { browserName, isMobile } from "react-device-detect";
import http from '../services/HttpService';

logger.enableAll(true);
logger.setLevel(logger.levels.INFO);

export const levelsEnum = Object.freeze({
  "DEBUG": "DEBUG",
  "ERROR": "ERROR",
  "INFO": "INFO",
  "SILENT": "SILENT",
  "TRACE": "TRACE",
  "WARN": "WARN",
})

const sendLogs = async (data, appName) => {
  console.log("THIS IS APP NAME", appName)
  const endpoint = `/system/log/application/errors/${appName}`;
  const response = await http.post(endpoint, data);
  return response;
}

export const recordError = (err, selectedLevel, appName) => {

  try {

    const level = selectedLevel.toLowerCase();
    const logLevel = Object.keys(logger.levels).find(c => c === selectedLevel);
    const request = err.response?.request;
    const errorDetail = { "endpoint": request.responseURL, "detail_response": request.response, "stackTrace": TypeError(err).stack.toString().replace(/(\r\n|\n|\r)/gm, "") };

    const error = {
      message: err.message,
      level: `${logLevel}`,
      mobile: isMobile,
      browser: browserName,
      stackTrace: JSON.stringify(errorDetail),//Source map is disabled so as to hide source code, to be enabled in the future for debugging purposes
      errorTime: err.response?.data.timestamp
    };


    if (process.env.NODE_ENV === "development") {
      logger[level](error)
    }

    sendLogs(error, appName);
  } catch (error) {
    console.log(error);
  }
};

export default logger;
